<template>
<div class="panel" v-if="mostrar">
    <span class="font-weight-black body-2 white--text">RECUPERACIONES </span><br />

    <div v-if="glosas!=0">
    <span class="font-weight-black  caption secondary--text ">Data Stage - Folio #{{glosas.folio}}</span><br/>
    <span class="caption secondary--text ">De: {{ (glosas.fecha_inicio!=null?glosas.fecha_inicio.substring(0,10):"")}} A: {{ (glosas.fecha_fin!=null?glosas.fecha_fin.substring(0,10):"") }}</span>
    
    <v-progress-linear :value="glosas.porcentaje" color="blue-grey" height="18"  >
            <strong title="Recuperados WS" v-tippy>{{ Math.ceil(glosas.porcentaje) }}%</strong>
    </v-progress-linear>
    <span class="caption secondary--text ">Pedimentos </span>
    <v-chip x-small color="primary">
       {{glosas.total_pedimentos}}
    </v-chip>
    <v-divider class="mb-1" />
    </div>
    <span class="font-weight-black  caption secondary--text ">Consulta Diaria - {{diaria.folio}}</span><br/>
    <v-progress-linear :value="diaria.porcentaje" color="blue-grey" height="18"  >
            <strong title="Estatus Pagado" v-tippy>{{ Math.ceil(diaria.porcentaje) }}%</strong>
    </v-progress-linear>
    <span class="caption secondary--text ">Pedimentos </span>
    <v-chip x-small color="primary">
       {{diaria.total_pedimentos}}
    </v-chip>
</div>
</template>

<script>
import axios from "axios";
export default {
    created() {
        this.carga();
    },
    methods: {
        carga: function (key) {
            var datos = {
                rfc: this.$local_storage.get("rfc"),
            }
            axios.post(this.$hostname + 'reportes/get_indicadores/', datos)
                .then((response) => {
                    if(response.data){
                        this.glosas = response.data.glosas||0;
                        this.diaria = response.data.diaria;
                        this.mostrar = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

    },
    components: {},
    name: 'barrasProgreso',
   
    data() {
        return {
            mostrar:false,
            glosas:"",
            diaria:""
        };
    },
};
</script>

<style scoped>
.panel {
    margin-left: 20px;
    margin-right: 10px;
}
</style>
